export var CustomFieldTextSearchType;
(function (CustomFieldTextSearchType) {
    CustomFieldTextSearchType[CustomFieldTextSearchType["EXACT"] = 1] = "EXACT";
    CustomFieldTextSearchType[CustomFieldTextSearchType["CONTAINS"] = 2] = "CONTAINS";
    CustomFieldTextSearchType[CustomFieldTextSearchType["NOT_CONTAINS"] = 3] = "NOT_CONTAINS";
})(CustomFieldTextSearchType || (CustomFieldTextSearchType = {}));
export var CustomFieldNumberSearchType;
(function (CustomFieldNumberSearchType) {
    CustomFieldNumberSearchType[CustomFieldNumberSearchType["EQUAL"] = 1] = "EQUAL";
    CustomFieldNumberSearchType[CustomFieldNumberSearchType["LESS_THAN"] = 2] = "LESS_THAN";
    CustomFieldNumberSearchType[CustomFieldNumberSearchType["GREATER_THAN"] = 3] = "GREATER_THAN";
})(CustomFieldNumberSearchType || (CustomFieldNumberSearchType = {}));
//# sourceMappingURL=custom-field-filters.i.js.map